import PropTypes from 'prop-types';
import React, { createContext } from 'react';

const LevelContext = createContext(1);

export const Heading = React.forwardRef((props, ref) => (
  <>
    {ref && <input ref={ref} readOnly className="ref-hidden" aria-hidden />}
    <LevelContext.Consumer>
      {(level) => {
        const Heading = `h${Math.min(level, 6)}`;
        return <Heading {...props} />;
      }}
    </LevelContext.Consumer>
  </>
));

export const Section = ({
  className,
  children,
  tag,
  levelOverride,
  ...rest
}) => {
  const SectionTag = tag;
  return (
    <LevelContext.Consumer>
      {(level) => (
        <LevelContext.Provider
          value={levelOverride ? parseInt(levelOverride, 10) : level + 1}
        >
          {SectionTag ? (
            <SectionTag className={className} {...rest}>
              {children}
            </SectionTag>
          ) : (
            children
          )}
        </LevelContext.Provider>
      )}
    </LevelContext.Consumer>
  );
};

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.string,
  levelOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Section.defaultProps = {
  className: null,
  tag: 'section',
  levelOverride: null,
  children: null,
};
